import React from 'react';
import { T } from 'shared/helper/translate';
var PageSection = function PageSection(_ref) {
  var header = _ref.header,
    children = _ref.children,
    className = _ref.className,
    sub = _ref.sub;
  var hasRenderableChildren = Array.isArray(children) ? children.filter(function (child) {
    return child;
  }).length > 0 : !!children;
  if (!hasRenderableChildren) return null;
  if (sub) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-75 mx-auto ".concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-12 text-center p-4 m-3"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "rubriq-plans-header fw-normal"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.plan-page-header"
    })), /*#__PURE__*/React.createElement("p", {
      className: "p-0"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.plan-page-header-description"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "m-0"
    }, children));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto ".concat(className)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rubriq-section-header py-3"
  }, header))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, children));
};
export default PageSection;